import * as Phaser from "phaser-ce"
import { CCUtils } from "../../../common/CCUtils"
import { COLOR } from "../../../common/Color"
import { TransitionState } from "../../GameState"
import { ColorUtils } from "../../utils/ColorUtils"
import { PhaserUtils } from "../../utils/PhaserUtils"
import { Scale } from "../../utils/Scale"
import { addVideoGroup, TestimonialOutroInfo, VideoInfo } from "../../utils/TestimonialOutro"
import { AddictionRoadExitAssets } from "../addiction-road/AddictionRoadAssets"
import { PongAssets } from "./PongAssets"


export class PongOrAddictionRoadExit extends Phaser.State {

    constructor(private pong: boolean, private videoKey?: string, private testimonialIntroAudio?: string) {
        super()
    }

    preload() {
        const load = PhaserUtils.makeLoader(this.game, "pong/transitions/testimonials")

        load.image(PongAssets.TESTIMONIAL_1_IMAGE, "testimonial-1.jpg")
        load.image(PongAssets.TESTIMONIAL_2_IMAGE, "testimonial-2.jpg")
        load.image(PongAssets.TESTIMONIAL_3_IMAGE, "testimonial-3.jpg")
        load.image(PongAssets.TESTIMONIAL_4_IMAGE, "testimonial-4.jpg")

        load.video(PongAssets.TESTIMONIAL_1, "testimonial-1.mp4")
        load.video(PongAssets.TESTIMONIAL_2, "testimonial-2.mp4")
        load.video(PongAssets.TESTIMONIAL_3, "testimonial-3.mp4")
        load.video(PongAssets.TESTIMONIAL_4, "testimonial-4.mp4")

        let videoLocation

        if (this.pong) {

            this.testimonialIntroAudio = CCUtils.genderifyFileName(`testimonials.mp3`)
            load.audio(PongAssets.BUDDY_TESTIMONIALS_INTRO, this.testimonialIntroAudio)
            this.videoKey = PongAssets.OUTRO1
            videoLocation = CCUtils.asset(CCUtils.genderifyFileName(`pong/transitions/outro.mp4`))

        } else {

            const loadRoad = PhaserUtils.makeLoader(this.game, "addiction-road/transitions/testimonials")
            this.testimonialIntroAudio = CCUtils.genderifyFileName(`testimonials.mp3`)
            loadRoad.audio(AddictionRoadExitAssets.BUDDY_TESTIMONIALS_INTRO, this.testimonialIntroAudio)
            this.videoKey = AddictionRoadExitAssets.OUTRO1
            videoLocation = CCUtils.asset(CCUtils.genderifyFileName(`addiction-road/transitions/outro.mp4`))

        }

        this.game.load.video(this.videoKey, videoLocation)
    }

    async create() {
        await PhaserUtils.sharedCreateFunctions(this.game)
        Scale.resizeScreen(this.game, true)
        ColorUtils.setBackgroundColor(this.game, COLOR.black)

        const outroInfo = new TestimonialOutroInfo()

        outroInfo.testimonialIntroAudio = PongAssets.BUDDY_TESTIMONIALS_INTRO
        outroInfo.testimonials = [
            new VideoInfo(PongAssets.TESTIMONIAL_1_IMAGE, PongAssets.TESTIMONIAL_1),
            new VideoInfo(PongAssets.TESTIMONIAL_2_IMAGE, PongAssets.TESTIMONIAL_2),
            new VideoInfo(PongAssets.TESTIMONIAL_3_IMAGE, PongAssets.TESTIMONIAL_3),
            new VideoInfo(PongAssets.TESTIMONIAL_4_IMAGE, PongAssets.TESTIMONIAL_4),
        ]


        if (this.pong) {
            outroInfo.goTo = TransitionState.ADDICTION_PONG_EXIT2
        } else {
            outroInfo.goTo = TransitionState.ADDICTION_ROAD_EXIT2
        }

        addVideoGroup(this.game, outroInfo, this.videoKey)
    }


}
